import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { productRepo } from "../../services";
import { addToCustomerCart } from "../../services/commerce";
import { useApp } from "../../context/AppContext";
import { useI18n } from "../../i18n";
import { Button, Card, Qty, Skeleton, baht, useAsync } from "../../components/ui";
import Icon from "../../components/ui/Icon";

export default function ServiceDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { orgId, toast, hasModule } = useApp();
  const { tx } = useI18n();
  const { data: product, loading } = useAsync(() => productRepo.get(orgId, id), [orgId, id]);
  const [quantity, setQuantity] = useState(1);

  if (loading || !product) return <Skeleton height={280} />;

  const addToCart = () => {
    addToCustomerCart(orgId, product.id, quantity); // เก็บแค่ productId + จำนวน ราคาคิดใหม่ตอนแสดง/จ่าย
    toast(tx("เพิ่มลงตะกร้าแล้ว", "Added to cart"), "success");
    navigate("/app/cart");
  };

  const bookNow = () => navigate("/app/booking", { state: { productId: product.id } });

  return (
    <>
      <Card>
        <div style={{ aspectRatio: "16/9", background: "linear-gradient(135deg, var(--c-indigo-500), var(--c-violet))", borderRadius: 12, marginBottom: 12, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 40 }}>
          <Icon name="tag" size={34} />
        </div>
        <div className="u-strong u-fs-18">{product.name}</div>
        <div className="u-fs-13 u-muted u-mb-8">{product.category}</div>
        <div style={{ fontSize: 26, fontWeight: 900 }} className="u-indigo">{baht(product.price, 0)}</div>
      </Card>

      <Card title={tx("จำนวน", "Quantity")}>
        <Qty value={quantity} onChange={setQuantity} />
      </Card>

      <div style={{ display: "grid", gap: 10 }}>
        {hasModule("booking") && (product.type === "service" || product.type === "package") ? (
          <Button variant="primary" block onClick={bookNow}><Icon name="calendar" /> {tx("จองคิวเลย", "Book now")}</Button>
        ) : null}
        <Button variant="soft" block onClick={addToCart}><Icon name="cart" /> {tx("เพิ่มลงตะกร้า", "Add to cart")}</Button>
      </div>
    </>
  );
}
